/**
 * Path B — Pipecat broker (Deepgram + Claude + Cartesia).
 *
 * Server URL: wss://<cloudfront-domain>/pipecat/ (CloudFront proxies to the
 * Pipecat ALB). For local dev, set VITE_PIPECAT_URL to the ALB ws:// URL.
 *
 * Wire format gap: Pipecat's WebsocketServerTransport uses ProtobufFrameSerializer
 * which the browser doesn't speak natively. Two options to resolve before
 * Path B is end-to-end functional:
 *   (a) Add `@pipecat-ai/client-js` and use its bundled transport
 *   (b) Switch the server's serializer to JsonFrameSerializer
 * Both are 1-day tasks. Audio handling here is scaffolded but the encode/decode
 * needs the protobuf shim or a server-side change to actually round-trip audio.
 */
import { WebsocketAudioPathAdapter } from "./websocket-audio";

const ENDPOINT = (import.meta as any).env?.VITE_PIPECAT_URL || "/pipecat/";

export class PipecatPathAdapter extends WebsocketAudioPathAdapter {
  protected getEndpoint(): string {
    // If running on the deployed origin, derive wss:// from current location.
    if (ENDPOINT.startsWith("ws")) return ENDPOINT;
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${proto}//${window.location.host}${ENDPOINT}`;
  }

  protected handleText(payload: string): void {
    try {
      const evt = JSON.parse(payload);
      if (evt.type === "transcript" && evt.role === "user") {
        this.emit({ role: "user", content: evt.content });
      } else if (evt.type === "transcript" && evt.role === "assistant") {
        this.emit({ role: "bot", content: evt.content });
      } else if (evt.type === "tool_call" || evt.type === "tool_use") {
        this.toolCalls += 1;
        this.emit({ role: "tool", content: `${evt.name}(${JSON.stringify(evt.arguments ?? {})})`, toolName: evt.name });
        this.pushMetric({});
      }
    } catch {
      // Ignore malformed events; they're informational.
    }
  }
}
